function payment_gate_check(label, detail, result) {
  const gate_check = {
    label,
    detail,
    result,
    result_label: result === 'pass' ? 'Pass' : 'Fail'
  };
  return gate_check;
}

export const payment_drawers = {
  inv_2219: {
    section: 'PAYMENT - INV-2219 - ICT - HARDWARE',
    supplier: 'ABC Tech Solutions',
    amount: 'R 88 000',
    po: 'PO PO-1184',
    status: 'Blocked by gate',
    status_class: 'bg-danger-subtle text-danger-emphasis',
    gate_title: 'Payment Compliance Gate - BLOCKED',
    gate_summary: '3 blocking checks must pass before this payment can be released.',
    gate_tone: 'danger',
    score: '4/7',
    checks: [
      payment_gate_check('Supplier compliance valid', 'Active, not suspended; tax / CSD / BBBEE in date', 'fail'),
      payment_gate_check('Valid purchase order', 'Approved PO exists and matches invoice', 'pass'),
      payment_gate_check('Goods/services received', 'GRN or delivery note confirms receipt', 'fail'),
      payment_gate_check('3-way match (Invoice-PO-Contract)', 'Quantities & amounts reconcile within tolerance', 'fail'),
      payment_gate_check('Approval threshold met', 'Authorised at the right delegation level', 'pass'),
      payment_gate_check('Within budget', 'Charged to a budget line with available funds', 'pass'),
      payment_gate_check('No duplicate payment', 'Not previously paid; no duplicate invoice number', 'pass')
    ],
    quick_link: 'Open supplier compliance',
    note: 'Supplier tax clearance expired; no GRN; 3-way match fails.',
    footer_hint: 'Override',
    footer_action: 'Cannot release',
    footer_action_class: 'finance-drawer-footer-btn is-danger',
    footer_action_icon: 'bi-slash-circle'
  },
  inv_2204: {
    section: 'PAYMENT - INV-2204 - FACILITIES - MAINTENANCE',
    supplier: 'GreenBuild Projects',
    amount: 'R 420 000',
    po: 'PO PO-1170',
    status: 'Cleared for payment',
    status_class: 'bg-success-subtle text-success-emphasis',
    gate_title: 'Payment Compliance Gate - CLEARED',
    gate_summary: 'All blocking compliance checks pass.',
    gate_tone: 'success',
    score: '7/7',
    checks: [
      payment_gate_check('Supplier compliance valid', 'Active, not suspended; tax / CSD / BBBEE in date', 'pass'),
      payment_gate_check('Valid purchase order', 'Approved PO exists and matches invoice', 'pass'),
      payment_gate_check('Goods/services received', 'GRN or delivery note confirms receipt', 'pass'),
      payment_gate_check('3-way match (Invoice-PO-Contract)', 'Quantities & amounts reconcile within tolerance', 'pass'),
      payment_gate_check('Approval threshold met', 'Authorised at the right delegation level', 'pass'),
      payment_gate_check('Within budget', 'Charged to a budget line with available funds', 'pass'),
      payment_gate_check('No duplicate payment', 'Not previously paid; no duplicate invoice number', 'pass')
    ],
    note: 'All gate checks pass; ready for release.',
    footer_action: 'Release payment',
    footer_action_class: 'finance-drawer-footer-btn is-success',
    footer_action_icon: 'bi-check-circle'
  },
  inv_2199: {
    section: 'PAYMENT - INV-2199 - ICT - SERVICES',
    supplier: 'BlueData Services',
    amount: 'R 120 000',
    po: 'No PO linked',
    status: 'Blocked by gate',
    status_class: 'bg-danger-subtle text-danger-emphasis',
    gate_title: 'Payment Compliance Gate - BLOCKED',
    gate_summary: '4 blocking checks must pass before this payment can be released.',
    gate_tone: 'danger',
    score: '3/7',
    checks: [
      payment_gate_check('Supplier compliance valid', 'Active, not suspended; tax / CSD / BBBEE in date', 'fail'),
      payment_gate_check('Valid purchase order', 'Approved PO exists and matches invoice', 'fail'),
      payment_gate_check('Goods/services received', 'GRN or delivery note confirms receipt', 'fail'),
      payment_gate_check('3-way match (Invoice-PO-Contract)', 'Quantities & amounts reconcile within tolerance', 'fail'),
      payment_gate_check('Approval threshold met', 'Authorised at the right delegation level', 'pass'),
      payment_gate_check('Within budget', 'Charged to a budget line with available funds', 'pass'),
      payment_gate_check('No duplicate payment', 'Not previously paid; no duplicate invoice number', 'pass')
    ],
    quick_link: 'Open supplier compliance',
    note: 'No PO; supplier DPA and tax evidence incomplete; goods receipt missing.',
    footer_hint: 'Override',
    footer_action: 'Cannot release',
    footer_action_class: 'finance-drawer-footer-btn is-danger',
    footer_action_icon: 'bi-slash-circle'
  },
  inv_2237: {
    section: 'PAYMENT - INV-2237 - OPERATIONS - FLEET',
    supplier: 'Atlas Cloud Infrastructure',
    amount: 'R 28 000',
    po: 'PO PO-1190',
    status: 'Blocked by gate',
    status_class: 'bg-danger-subtle text-danger-emphasis',
    gate_title: 'Payment Compliance Gate - BLOCKED',
    gate_summary: '1 blocking check must pass before this payment can be released.',
    gate_tone: 'danger',
    score: '6/7',
    checks: [
      payment_gate_check('Supplier compliance valid', 'Active, not suspended; tax / CSD / BBBEE in date', 'pass'),
      payment_gate_check('Valid purchase order', 'Approved PO exists and matches invoice', 'pass'),
      payment_gate_check('Goods/services received', 'GRN or delivery note confirms receipt', 'fail'),
      payment_gate_check('3-way match (Invoice-PO-Contract)', 'Quantities & amounts reconcile within tolerance', 'pass'),
      payment_gate_check('Approval threshold met', 'Authorised at the right delegation level', 'pass'),
      payment_gate_check('Within budget', 'Charged to a budget line with available funds', 'pass'),
      payment_gate_check('No duplicate payment', 'Not previously paid; no duplicate invoice number', 'pass')
    ],
    note: 'Awaiting goods-received confirmation.',
    footer_hint: 'Override',
    footer_action: 'Cannot release',
    footer_action_class: 'finance-drawer-footer-btn is-danger',
    footer_action_icon: 'bi-slash-circle'
  },
  inv_2241: {
    section: 'PAYMENT - INV-2241 - ICT - SECURITY',
    supplier: 'Sentinel Cybersecurity',
    amount: 'R 64 000',
    po: 'PO PO-1192',
    status: 'Cleared for payment',
    status_class: 'bg-success-subtle text-success-emphasis',
    gate_title: 'Payment Compliance Gate - CLEARED',
    gate_summary: 'All blocking compliance checks pass.',
    gate_tone: 'success',
    score: '7/7',
    checks: [
      payment_gate_check('Supplier compliance valid', 'Active, not suspended; tax / CSD / BBBEE in date', 'pass'),
      payment_gate_check('Valid purchase order', 'Approved PO exists and matches invoice', 'pass'),
      payment_gate_check('Goods/services received', 'GRN or delivery note confirms receipt', 'pass'),
      payment_gate_check('3-way match (Invoice-PO-Contract)', 'Quantities & amounts reconcile within tolerance', 'pass'),
      payment_gate_check('Approval threshold met', 'Authorised at the right delegation level', 'pass'),
      payment_gate_check('Within budget', 'Charged to a budget line with available funds', 'pass'),
      payment_gate_check('No duplicate payment', 'Not previously paid; no duplicate invoice number', 'pass')
    ],
    note: 'Within tolerance; all checks pass.',
    footer_action: 'Release payment',
    footer_action_class: 'finance-drawer-footer-btn is-success',
    footer_action_icon: 'bi-check-circle'
  },
  inv_2248: {
    section: 'PAYMENT - INV-2248 - PROFESSIONAL SERVICES',
    supplier: 'NewGX Capital',
    amount: 'R 520 000',
    po: 'PO PO-1195',
    status: 'Blocked by gate',
    status_class: 'bg-danger-subtle text-danger-emphasis',
    gate_title: 'Payment Compliance Gate - BLOCKED',
    gate_summary: '1 blocking check must pass before this payment can be released.',
    gate_tone: 'danger',
    score: '5/7',
    checks: [
      payment_gate_check('Supplier compliance valid', 'Active, not suspended; tax / CSD / BBBEE in date', 'pass'),
      payment_gate_check('Valid purchase order', 'Approved PO exists and matches invoice', 'pass'),
      payment_gate_check('Goods/services received', 'GRN or delivery note confirms receipt', 'pass'),
      payment_gate_check('3-way match (Invoice-PO-Contract)', 'Quantities & amounts reconcile within tolerance', 'pass'),
      payment_gate_check('Approval threshold met', 'Authorised at the right delegation level', 'fail'),
      payment_gate_check('Within budget', 'Charged to a budget line with available funds', 'fail'),
      payment_gate_check('No duplicate payment', 'Not previously paid; no duplicate invoice number', 'pass')
    ],
    note: 'Above CFO-only threshold (needs CEO); professional-services budget exceeded.',
    footer_hint: 'Override',
    footer_action: 'Cannot release',
    footer_action_class: 'finance-drawer-footer-btn is-danger',
    footer_action_icon: 'bi-slash-circle'
  },
  inv_2250: {
    section: 'PAYMENT - INV-2250 - ICT - HARDWARE',
    supplier: 'ABC Tech Solutions',
    amount: 'R 88 000',
    po: 'PO PO-1184',
    status: 'Blocked by gate',
    status_class: 'bg-danger-subtle text-danger-emphasis',
    gate_title: 'Payment Compliance Gate - BLOCKED',
    gate_summary: '3 blocking checks must pass before this payment can be released.',
    gate_tone: 'danger',
    score: '4/7',
    checks: [
      payment_gate_check('Supplier compliance valid', 'Active, not suspended; tax / CSD / BBBEE in date', 'fail'),
      payment_gate_check('Valid purchase order', 'Approved PO exists and matches invoice', 'pass'),
      payment_gate_check('Goods/services received', 'GRN or delivery note confirms receipt', 'pass'),
      payment_gate_check('3-way match (Invoice-PO-Contract)', 'Quantities & amounts reconcile within tolerance', 'fail'),
      payment_gate_check('Approval threshold met', 'Authorised at the right delegation level', 'pass'),
      payment_gate_check('Within budget', 'Charged to a budget line with available funds', 'pass'),
      payment_gate_check('No duplicate payment', 'Not previously paid; no duplicate invoice number', 'fail')
    ],
    quick_link: 'Open supplier compliance',
    note: 'Possible duplicate of INV-2219 (same supplier, amount, PO).',
    footer_hint: 'Override',
    footer_action: 'Cannot release',
    footer_action_class: 'finance-drawer-footer-btn is-danger',
    footer_action_icon: 'bi-slash-circle'
  }
};

function pending_payment_purchase_order(form) {
  const purchase_order = form.purchase_order ? `PO ${form.purchase_order}` : 'PO to be linked';
  return purchase_order;
}

function pending_payment_note(form) {
  const note = (form.note || 'Compliance context pending review.').trim();
  return note;
}

export function create_pending_payment_drawer(invoice, form, amount) {
  const payment_payload = {
    section: `PAYMENT - ${invoice} - ${(form.budget_line || 'NEW INVOICE').toUpperCase()}`,
    supplier: (form.supplier || '').trim() || 'Supplier name',
    amount,
    po: pending_payment_purchase_order(form),
    status: 'Pending gate setup',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    gate_title: 'Payment Compliance Gate - PENDING',
    gate_summary: 'Invoice captured. Gate checks will populate in the payment detail.',
    gate_tone: 'warning',
    score: '0/7',
    checks: [
      payment_gate_check('Supplier compliance valid', 'Supplier verification will run once linked to onboarding records', 'fail'),
      payment_gate_check('Valid purchase order', 'PO match will run after purchase order is confirmed', 'fail'),
      payment_gate_check('Goods/services received', 'Receipt evidence has not been attached yet', 'fail'),
      payment_gate_check('3-way match (Invoice-PO-Contract)', 'Will calculate after invoice, PO and contract are linked', 'fail'),
      payment_gate_check('Approval threshold met', 'Delegation approval has not been assessed yet', 'fail'),
      payment_gate_check('Within budget', 'Budget line funding will be confirmed in the gate', 'fail'),
      payment_gate_check('No duplicate payment', 'Duplicate detection will run after save', 'fail')
    ],
    note: pending_payment_note(form),
    footer_hint: 'Awaiting review',
    footer_action: 'Cannot release',
    footer_action_class: 'finance-drawer-footer-btn is-danger',
    footer_action_icon: 'bi-slash-circle'
  };
  return payment_payload;
}
